import React, { useState } from 'react';
import { Container, InputContainer } from './styles'
import { AiOutlineInfoCircle } from 'react-icons/ai';


export const InputUrl = ({ value, setValue, error, ...props }) => {
  const [open, setOpen] = useState(false);
  const [isInvalidUrl, setIsInvalidUrl] = useState(false);

  const handleUrl = (e) => {
    const value = e.target.value.toLowerCase().replace(' ', '-');
    const regex = /^[a-zA-Z0-9/-]*$/;

    if (!regex.test(value)) {
      // setIsInvalidUrl(true);
      return;
    }

    // setIsInvalidUrl(false);
    setValue(value);
  }

  return (

    <Container >
      <div>
        <label>URL do painel </label>

        <div className='info_container'
          onMouseEnter={() => setOpen(true)}
          onMouseLeave={() => setOpen(false)}
        >
          <AiOutlineInfoCircle size={18} />

          {open && (
            <div className='msg_container'>
              A URL não deve conter caracteres
              especiais, pontuação ou acentos.
            </div>
          )}
        </div>
      </div>

      <InputContainer>
        <div>
          <input
            value={value}
            onChange={handleUrl}
            {...props}
          />
          <div className='pre_url'>voitto.com.br</div>
        </div>
        {isInvalidUrl && <p>caractere inválido</p>}
        {<span>{'A url não deve conter caracteres especiais, pontuação, acentos, www, incompany, painel-empresa ou blogs'}</span>}
        {error && <p>{error}</p>}
      </InputContainer>

    </Container>
  )
}
